import Skeleton from '@pedidosya/web-fenix/system/Skeleton';
import React, { memo } from 'react';
import styled from 'styled-components';

const WrapperFilter = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding-left: 16px;
  padding-top: 10px;
`;

const SkeletonFilter = memo(() => (
  <WrapperFilter>
    <Skeleton height="7" shape="square" width="24" />
    <Skeleton height="7" shape="square" width="24" />
    <Skeleton height="7" shape="square" width="24" />
    <Skeleton height="7" shape="square" width="24" />
  </WrapperFilter>
));

export default memo(SkeletonFilter);
